import React, { //useState, useEffect
 } from 'react';
 
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableFooter from '@mui/material/TableFooter';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import LastPageIcon from '@mui/icons-material/LastPage';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import Info from '@mui/icons-material/Info';
import Grid from '@mui/material/Grid';

import useStyles from '../styles/Styles';
import { styled } from '@mui/material/styles';

import _ from 'lodash';

import { describeDate, describeTime, isFinished } from '../utils';

const EnrolmentsTable = ({items, itemsLabel, itemLabel, totalLength, fields, page, pages, perPage, setPage, size, flexLayout, 
openItem, setInvoiceUnpaid, openRemoveItem, setUndoingRemoval, openSettings}) => {
	const classes = useStyles();
	
	const fieldsLength = _.size(fields);
	const isSmd = !flexLayout;
	
	const InfoNote = styled(Typography)(() => ({
		marginTop: '0.35em',
		maxWidth: '250px',
		textDecoration: 'none !important',
		'& svg': {
			verticalAlign: 'bottom',
		}
	}));
	
	const formatField = (type, value) => {
		switch(type){
			case 'start_date':
			case 'finish_date':
				return describeDate(value);
			case 'start':
				return <>{describeDate(value.start_date)}<br/>{describeTime(value.start_time)}</>
			case 'start_time':
				return describeTime(value);
			case 'amount_charged':
			case 'amount_paid':
				return '$' + value;
			case 'course':
				let note = '';
				if(value.status === 'Deleted'){
					note = 'You have been withdrawn from this ' + itemLabel + '.'
				} else if (_.toNumber(value.withdrawal_requested) === 1){
					note = 'You have requested to be withdrawn from this ' + itemLabel + '.'
				}
				return <>
				<Typography variant="subtitle2">{value.course_name}</Typography>
				<Typography>{value.course_code}</Typography>
				{ note ? <InfoNote variant="body2">
					<Info color="primary" /> {note}</InfoNote> : null}
				</>
			case 'invoice_no':
				const unpaid = _.toNumber(value.amount_charged) > _.toNumber(value.amount_paid) && value.status !== 'Waitlist' ? true : false;
				return <Button color="primary" variant="outlined"
						onClick={() => {
							openItem(value.invoice_no);
							setInvoiceUnpaid(unpaid);
						}}
					>{value.invoice_no}</Button>
			case 'detail':
				const unpaidCourse = _.toNumber(value.amount_charged) > _.toNumber(value.amount_paid) && value.status !== 'Waitlist' ? true : false;
				const canRequestRemoval = _.toNumber(value.withdrawal_requested) === 0 && value.status !== 'Deleted' && !isFinished(value.finish_date);
				const canCancelRemoval = _.toNumber(value.withdrawal_requested) > 0 && value.status !== 'Deleted';
				return <div><Button color="primary" variant="contained" size="small"
					onClick={() => {
						openItem(value);
						setInvoiceUnpaid(unpaidCourse);
					}}
					>Show Detail</Button>
					{canRequestRemoval ? 
					<Button color="primary" variant="outlined" size="small"
					onClick={() => {
						openRemoveItem(value);
						setUndoingRemoval(false);
					}}
					>Request Removal</Button>
					: (
						canCancelRemoval ?
						<Button color="primary" variant="outlined" size="small"
						onClick={() => {
							openRemoveItem(value);
							setUndoingRemoval(true);
						}}
						>Cancel Removal Request</Button>
						 : null
					)}
					</div>
			default: // course_code, course_name, invoice_no, (status), interest_code, short_comment, points, venue_code
				return value;
		}
	}
	
	const getAlignment = (type) => {
		return _.includes(['amount_charged', 'amount_paid', 'invoice_no', 'points'], type) ? 'right' : 'left';
	}
	
	return (<Table className={classes.enrolmentsTable} size={size}>
		{flexLayout ? null :
		<TableHead>
		<TableRow>
		{_.map(fields, (f, k) => (
			<TableCell key={k} align={flexLayout ? 'left' : getAlignment(k)}>
				{f}
			</TableCell>
		))}
		</TableRow>
		</TableHead>
		}
		
		<TableBody className={flexLayout ? classes.enrolmentsFlexTable : null}>
		{_.map(items, (i, k) => (
			<TableRow key={k} className={
				i.status && i.status === 'Deleted' ? classes.deletedItem :
				(i.amount_charged && _.toNumber(i.amount_charged) > _.toNumber(i.amount_paid) && i.status !== 'Waitlist' ? classes.dueItem
				: null)}
			>
			{_.map(fields, (f, k) => (
				<TableCell key={k} align={flexLayout ? 'left' : getAlignment(k)} data-column={k}>
					{flexLayout ? <strong>{fields[k]}: </strong> : null}{_.includes(['invoice_no', 'detail', 'course', 'start', 'dates'], k) ? formatField(k, i) : formatField(k, i[k])}
				</TableCell>
			))}
			</TableRow>
		))}
		</TableBody>
		<TableFooter className={flexLayout ? classes.enrolmentsFlexFooter : null}>
		<TableRow>
		<TableCell colSpan={fieldsLength}>
		<Grid container spacing={isSmd ? 1: 2} 
			alignItems="center"
			justifyContent={isSmd ? 'space-between' : 'center'} 
			direction={isSmd ? 'row' : 'column'}
		>
		<Grid item  xs={isSmd ? 5 : 12}>
		<Typography variant="body1">
		{itemsLabel}: {totalLength === 0 ? 0 : (page - 1) * perPage + 1}-{page < pages ? page * perPage : totalLength} of {totalLength}
		</Typography>
		</Grid>
		<Grid item container xs={isSmd ? 7 : 12} 
			alignItems="center"
			justifyContent={isSmd ? 'flex-end' : 'center'} 
			spacing={isSmd ? 2 : 1}
		>

		{ openSettings ? 
		<Grid item>
		<Button color="primary" variant="contained" size={size}
			onClick={() => openSettings(true)}
		>Settings</Button>
		</Grid>
		: null }
		{ totalLength > 0 ? 
		<Grid item>
		<IconButton aria-label="first page" color="primary" disabled={page < 2} size={size}
			onClick={() => setPage(1)}
		>
		  <FirstPageIcon />
		</IconButton>
		<IconButton aria-label="previous page" color="primary" disabled={page < 2} size={size}
			onClick={() => setPage(page - 1)}
		>
		  <NavigateBeforeIcon />
		</IconButton>
		<IconButton aria-label="next page" color="primary" disabled={page === pages} size={size}
			onClick={() => setPage(page + 1)}
		>
		  <NavigateNextIcon />
		</IconButton>
		<IconButton aria-label="last page" color="primary" disabled={page === pages} 
			size={size}
			edge='end'
			onClick={() => setPage(pages)}
		>
		  <LastPageIcon />
		</IconButton>
		</Grid>
		: null }
		</Grid>
		</Grid>
		</TableCell>
		</TableRow>
		</TableFooter>
		</Table>
	
)};

export default EnrolmentsTable